

export function setAccountsFrom(state, accounts_from) {
    state.accounts_from = accounts_from
}

export function setContacts(state, contacts) {
    state.contacts = contacts;
}
export function setLines(state, lines){
    state.lines = lines
}
export function setreporte_comisiones(state, reporte_comisiones) {
    state.reporte_comisiones = reporte_comisiones
    /*let pagos = state.reporte_comisiones_pagos.data;
    let descuentos = state.reporte_comisiones_descuentos.data;

    reporte_comisiones.data.map(p => {
        let pagos_find = pagos.filter(
            x => {
                if (x.document_id == p.document_id && x.affects_document_id == p.affects_document_id)
                    return x
            }
        )
        let descuentos_find = descuentos.filter(
            g => {
                if (g.document_id == p.document_id && g.affects_document_id == p.affects_document_id )
                    return g
            }
        )
            ? descuentos.filter(
                g => {
                    if (g.document_id == p.document_id && g.affects_document_id == p.affects_document_id )
                        return g
                }
            )
            : "0";

        let pagos_amount = 0 ;
        pagos_find.forEach( item => {
            pagos_amount+= parseFloat(item.value)
        })

        let discounts_amount = 0 ;
        descuentos_find.forEach( item => {
            discounts_amount+= parseFloat(item.value)
        })

        p.pay = (pagos_amount/1.19) - discounts_amount
        p.pay_with_iva = pagos_amount - discounts_amount
        p.discount = discounts_amount;
    })
*/

    //console.log(reporte_comisiones);
}
export function setParams(state, params){
    state.params = params
}

export function setreporte_comisiones_descuento(state,reporte_comisiones_descuentos){

    state.reporte_comisiones_descuentos = reporte_comisiones_descuentos
}

export function setreporte_comisiones_pagos(state,reporte_comisiones_pagos){
    state.reporte_comisiones_pagos = reporte_comisiones_pagos
}



// WEBPACK FOOTER //
// ./src/modules/report-commisions/mutations.js